import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";

import commoncss from "./../../css/common.module.css";
import libcss from "../../css/library.module.css";
import buttoncss from "./../../css/button.module.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import adminPortalCss from "../../css/adminportal.module.css";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchPri.svg";
import {
  getAllLinkedFSApiHandler,
  overrideFSApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

const OverrideFSModal = ({ groupingTemplateID, setShowOverrideModal }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [linkedFSList, setLinkedFSList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getAllLinkedFSApiHandler(groupingTemplateID)
      .then((response) => {
        const linkedFSArray = response?.data?.linkedFSArray ?? [];
        console.log("linkedFSArray", linkedFSArray);

        setLinkedFSList(linkedFSArray);
      })
      .catch((error) => {
        swal(
          "Error",
          error.response.data.error || "Error: Get Linked Register API Failed!",
          "error"
        );
      });
  }, []);

  useEffect(() => {
    console.log("selectedItem", selectedItem);
  }, [selectedItem]);
  const data = [...Array(12)].map((_, i) => ({
    id: i + 1,
    label: `FS ${i + 1}`,
  }));

  const [checkedFS, setCheckedFS] = useState([]);

  const handleChange = (id, isChecked) => {
    setCheckedFS((prev) =>
      isChecked ? [...prev, id] : prev.filter((x) => x !== id)
    );
  };

  const handleOverride = () => {
    if (selectedItem === "dont_override") {
      return setShowOverrideModal(false);
    } else {
      const allFS = linkedFSList.map((item) => item._id);
      const payload = {
        projectIDList: selectedItem === "override_all" ? allFS : checkedFS,
      };

      console.log("payload", payload);

      overrideFSApiHandler({ groupingTemplateID: groupingTemplateID }, payload)
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Override successful", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to Override",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to Override",
            "error"
          );
        });
    }
  };

  const filteredFSList = linkedFSList.filter((item) =>
    (item?.project_name || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase().trim())
  );

  return (
    <Modal
      width="35%"
      // minHeight="500px"
      title="Override"
      bodycss={commoncss.unsetPadding}
      headerActions={<CloseIcon onClick={() => setShowOverrideModal(false)} />}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={() => setShowOverrideModal(false)}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Continue"
            onClick={handleOverride}
          />
        </>
      }
    >
      <div style={{ padding: "10px 20px" }}>
        <div className={libcss.overrideNote}>
          This Template is linked to{" "}
          <span className={`${commoncss.fw600} ${commoncss.fs16}`} style={{  fontFamily: "DM Sans" }}>
            {linkedFSList.length} Financial statements
          </span>
          .<br /> How would you like to override the changes you have made?
        </div>
        <div
          className={adminPortalCss.radioButtonSection}
          style={{ justifyContent: "center", marginTop: "25px", marginBottom: "15px" }}
        >
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="override"
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
            className={adminPortalCss.radioSection}
            sx={{ gap: "25px" }}
          >
            <FormControlLabel
              value="override_all"
              className={adminPortalCss.radioLabel}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Override to all"
              sx={{
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontWeight: 400,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                  fontFamily: "DM Sans",
                },
              }}
            />
            <FormControlLabel
              className={adminPortalCss.radioLabel}
              value="override_selected"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Override to selected"
              sx={{
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontWeight: 400,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                  fontFamily: "DM Sans",
                },
              }}
            />
            <FormControlLabel
              className={adminPortalCss.radioLabel}
              value="dont_override"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Don't Override"
              sx={{
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontWeight: 400,
                  textTransform: "none",
                  fontFamily: "DM Sans",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
          </RadioGroup>
        </div>
        {selectedItem === "override_selected" && (
          <div className={`${libcss.selectFsDiv} my-3`} style={{ padding: "15px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#ffffff",
                border: "1px solid #c2e6d1",
                borderRadius: "8px",
                padding: "2px 8px",
                height: "36px",
                marginBottom: "20px",
                boxSizing: "border-box",
                width: "100%",
              }}
            >
              <SearchIcon
                style={{
                  width: "14px",
                  height: "14px",
                  marginRight: "6px",
                  flexShrink: 0,
                }}
              />
              <input
                type="text"
                placeholder="Select FS to override"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                  fontSize: "14px",
                  color: "#205a46",
                  width: "100%",
                  fontFamily: "DM Sans",
                  padding: 0,
                }}
              />
              {searchQuery && (
                <CloseIcon
                  onClick={() => setSearchQuery("")}
                  style={{
                    width: "10px",
                    height: "10px",
                    cursor: "pointer",
                    color: "#8fa39e",
                    flexShrink: 0,
                    marginLeft: "4px",
                  }}
                />
              )}
            </div>
            <div
              className={`${libcss.fsGrid} ${commoncss.hideScroll}`}
              style={{
                maxHeight: "150px",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {filteredFSList.length > 0 ? (
                filteredFSList.map((item) => (
                  <div key={item.id || item._id} className={libcss.fsItem}>
                    <input
                      type="checkbox"
                      checked={checkedFS.includes(item._id)}
                      onChange={(e) => handleChange(item._id, e.target.checked)}
                    />
                    <span style={{ fontSize: "14px" }}>{item.project_name}</span>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    gridColumn: "1 / -1",
                    textAlign: "center",
                    color: "#8fa39e",
                    fontSize: "13px",
                    padding: "16px 0",
                  }}
                >
                  No Financial Statements found 
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OverrideFSModal;
